import React  from 'react';
import { Redirect, Route } from "react-router-dom";
const AuthorizedRoute = ({ children, isAuthorized,  ...rest }) => {
  return (
    <Route
      {...rest}
      render={({ location }) =>
      isAuthorized ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/dashboard",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}
export default AuthorizedRoute;